module.exports = __webpack_public_path__ + "static/media/mi4.f5c3fd2b.jpg";